module.exports = __webpack_public_path__ + "img/潼南重庆涪江国家湿地公园@2x.39a4f309.png";